import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FieldDefinition} from "@shared/models/field-definition";

@Component({
    standalone: false,
    selector: 'app-formula-field-cell-viewer',
  templateUrl: './formula-field-cell-viewer.component.html',
  styleUrls: ['./formula-field-cell-viewer.component.scss']
})
export class FormulaFieldCellViewerComponent implements OnInit {

  fieldDefinition: FieldDefinition;
  item: any;
  @Output() valueChanged?: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  ngOnInit(): void {
  }

  onIconClicked() {
    const existingValue = !!this.item.cells[this.fieldDefinition.key] && !!this.item.cells[this.fieldDefinition.key].value;
    this.item.cells[this.fieldDefinition.key] = {value: !existingValue};
    this.valueChanged.emit({item: this.item, key: this.fieldDefinition.key, action: {id: 'Update'}});
  }

}
